module.exports = __webpack_public_path__ + "img/SketchPng944a0d2a2ea0b3eb6cc0a6f816543033e84e89500f29f107f4614d3b1aaa99ee.de7e2649.png";